import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'
import type BigBooksRoute from 'teacher-ui-client/subscription-type/big-books/route'

export default class BigBooksController extends Controller {
  queryParams = ['keywords', 'bigBookLevel']

  @tracked bigBookLevel: string = 'all'

  @tracked keywords = ''

  declare model: ModelFor<BigBooksRoute>
}

declare module '@ember/controller' {
  interface Registry {
    'subscription-type/big-books': BigBooksController
  }
}
